export const english = {
  Add_Account: "Add New Account",
  Select_Language: "Select Language",
  Welcome_to_BOSAGORA_Wallet: "Welcome to BOSAGORA Wallet",
  Secure_Easy_to_Use_Crypto_Wallet: "Secure & Easy to Use Crypto Wallet",
  Welcome_to_New_Wallet: "Create a new account.",
  Follow_these_steps_to_create_a_new_wallet:
    "Follow these steps to create a new wallet",
  Secret_Seed_or_Public_Key: "Secret Key or Public Key",
  Select_Account: "Select the account you want to add",
  Select_Account_not_registered: "There is no account that can be added",
  Enter_seed_or_public_Mandotary: "Enter secret key or public key",
  Wallet_Name: "Account Name(Optional)",
  Secret_Key: "Secret Key",
  Public_Key: "Public Key",
  Create_Wallet: "Create New Account",
  Create: "Create",
  Wallet_Note:
    "Be sure to save your Secret key securely. Do not show this Secret Key to anyone.",
  Confirm: "Confirm",
  Recent_Transactions: "Recent Transactions",
  Overview: "Overview",
  Unfreezing: "Unfreezing",
  UTXO: "UTXO",
  Filter: "Filters",
  Transaction_type: "Transaction type",
  Block_height: "Block height",
  Time: "Time",
  Peer: "Peer",
  Account: "Account",
  Lock_period: "Lock period",
  Pending_Transactions: " Pending Transactions",
  Submission_time: "Submission time",
  Block_delay: "Block delay",
  Target: "Target",
  Block_Height: "Block Height",
  Outbound_transaction: "Outbound transaction",
  From: "From",
  To: "To",
  Peer_Name: "Peer Name",
  Download: "Download",
  Inbound_transaction: "Inbound transaction",
  Fee: "Fee",
  Action: "Action",
  Transaction_History: "Transactions History",
  Receiver: "Receivers",
  Address: "Address",
  Sender: "Senders",
  Add_Sender: "Add Sender",
  Drawn: "Drawn",
  Remaining: "Remaining",
  Transaction_Fee: " Transaction Fee",
  NEXT: "Next",
  Transaction_Overview: "Transaction Overview",
  Transaction_Details: "Transaction Details",
  Senders_Detail: "Senders Detail",
  Receivers_Detail: "Receivers Detail",
  Transactions_History: "Transactions History",
  Total_Amount: "Total Amount",
  Amount: "Amount",
  Drawn_Amount: "Drawn Amount",
  Back: "Back",
  Transaction_has_been_successful: "Transaction has been successful",
  Create_Validator: "Create Validator",
  Freezing_Amount: "Freezing Amount",
  units_to_Stake_for_Flash: "Units to stake for Validator (0~996)",
  Add: "Add",
  Send_BOA: "Send BOA",
  Store_Data: "Store Data",
  Settings: "Settings",
  This_page_allows_you_to_create_contacts:
    "This page allows you to create contacts, making it easier for you to work with addresses by giving them an identifiable name",
  Add_Contact: "Add Contact",
  Contacts: "Contacts",
  Contact_Name_Table: "Contact Name",
  Contact_Name: "Contact Name (Optional)",
  Actions: "Actions",
  Contact_List: "Contact List",
  Total: "Total",
  Spendable: "Spendable",
  Spendable_Balance: "Spendable Balance",
  Balance: "Balance",
  Info: "Info",
  Contact_Name_Required:
    "Contact name is not required, but it can be used for your convenience",
  Cancel: "Cancel",
  Language: "Language",
  Dark_Mode: "Dark Mode",
  Endpoints: "Endpoints",
  Sending_Delay: "Sending Delay",
  Timezone: "Timezone",
  Set_Wallet_Name: "Set Account Name",
  Manage: "Manage",
  Reset_Wallet_State: "Reset Wallet State",
  Clear: "Clear",
  Edit: "Edit",
  CoinNet: "CoinNet",
  TestNet: "TestNet",
  Self_Balance: "Self Balance",
  Total_Balance: "Total Balance",
  Mode_status: "Mode status",
  Save: "Save",
  sorry_no_data: "No Data",
  Contact_address_already_exist: "Contact on this address already exists.",
  clear_all_states_wallet:
    "Do you want to clear all the states of the wallet? All saved settings and addresses will be cleared.",
  Edit_Contact_Name: "Edit Contact Name",
  Frozen_Amount: "Frozen Amount",
  Amount_Unfrozen: "Amount to be unfrozen",
  Pending_Transaction_Overview: "Pending Transaction Overview",
  Cancellation_Transaction_Overview: "Cancellation Transaction Overview",
  Payload_Fee: "Payload Fee",
  Freezing_Fee: "Freezing Fee",
  Cancel_Transaction: "Cancel Transaction",
  Input_payload: "Input payload (Base64)",
  About_Wallet: "About BOSAGORA Wallet",
  About_Wallet_LineOne:
    "BOSAGORA Wallet is a tool that connects to the BOSAGORA network through a web browser.",
  About_Wallet_LineTwo:
    "BOSAGORA Wallet was developed to help blockchain application development and was not specifically targeted to serve end-users.",
  About_Wallet_LineThree:
    "Please carefully read the “Disclaimer” and “Important Notice on Security” below. We assume that you acknowledge the basic characteristics of a blockchain.",
  Disclaimer: "Disclaimer",
  Disclaimer_LineOne:
    "BOSAGORA Wallet is provided “as-is”, without any warranty whatsoever. It does not guarantee performance of its intended function.",
  Disclaimer_LineTwo:
    "BOSAGORA does not guarantee that BOSAGORA Wallet will perform error-free or uninterrupted or that BOSAGORA will correct all errors. To the extent permitted by law, these warranties are exclusive and there are no other express or implied warranties or conditions, including warranties or conditions of merchantability or fitness for a particular purpose.",
  Disclaimer_LineThree:
    "In no case shall BOSAGORA be liable for any claim, damages, or any other liability rising out of the use of BOSAGORA Wallet.",
  Disclaimer_LineFour:
    "By using BOSAGORA Wallet, you acknowledge that you use BOSAGORA Wallet at your own risk.",
  Important_Notice: "Important Notice on Security",
  Important_Notice_LineOne:
    "BOSAGORA Wallet does not provide protection against attacks that attempt to illegally access your information through vulnerabilities of your web browser, operating system, or computer hardware.",
  Important_Notice_LineTwo:
    "BOSAGORA Wallet does not store your private key on the BOSAGORA network. When you access your account, your private key is stored in your browser’s local storage, and is automatically deleted when you close the browser tab or when you click the reset button.",
  Important_Notice_LineThree:
    "BOSAGORA Wallet or BOSAGORA can not restore lost private keys. Therefore, BOSAGORA strongly recommends that you securely store your private key on a separate offline storage device. Mismanagement or neglect of your information may result in irreversible loss of your assets.",
  I_agree: "I agree to all above",
  Accept: "Accept",
  Validator_Address: "Validator Address",
  New_Secret_Key: "New Secret Key",
  Keypair_Validator: "Keypair of new Validator",
  Select_Unfreezing: "Select UTXO for unfreezing",
  Add_New: "Add New Account",
  Yes: "Yes",
  No: "No",
  Ok: "OK",
  Useful_Info_Line1:
    "Please enter a secret key corresponding to the public address.",
  Useful_Info_Line2: "The secret key is essential for BOA transmission.",
  Useful_Info_Line3: "The secret key is not stored on the local computer.",
  Useful_Info_Line4:
    "The secret key or public key is essential for the transaction. The secret key or public key is not stored on the local computer.",
  Amount_is_not_enough: "Amount is not enough",
  Address_is_already_added: "Address is already added",
  Enter_a_valid_receiver_address_first: "Enter a valid receiver address first.",
  Enter_a_valid_Base64_format: "Enter a valid Base64 format.",
  Enter_a_valid_payload_length:
    "The maximum input value of the payload cannot exceed 1024 bytes. (Input length:{{length}} bytes)",
  Option: "Option",
  Account_already_register_with_this_address:
    "Account already registered with this address.",
  This_key_is_not_valid: "This key is not valid.",
  Enter_units_to_stake_for_flash_upto_100:
    "Enter Units to stake for Validator upto 100.",
  Enter_units_to_stake_for_flash_upto_996:
    "Enter Units to stake for Validator upto 996.",
  Send: "Send",
  Previous: "Previous",
  Create_Send_Transaction:
    "Creates and sends a transaction whose sender's address is the same as the receiver's.",
  New_Cancellation_Transactions:
    "New cancellation transactions can be ignored if previously transmitted transactions are stored in blocks.",
  Press_Cancellation_Transactions:
    " If you want to cancel this transaction, please press the “Cancel Transaction” button below.",
  Fee_Error: "Fee cannot be less than 0.01",
  Light_Mode: "Light Mode",
  Error_in_Encryption: "Error in Encryption.",
  Invalid_Fee: "Invalid Fee.",
  Invalid_default_fee: "Invalid default fee.",
  Invalid_Address: "Invalid Address.",
  Something_went_wrong: "Something went wrong.",
  Account_with_this_name_is_already_added:
    "Account with this name has already been added.",
  Contact_with_this_name_already_exists:
    "Contact with this name already exists.",
  You_cant_add_your_own_address_to_contact_list:
    "You can't add your own address to the contact list.",
  Enter_valid_receiver_address_first: "Enter valid receiver address first.",
  Address_not_found: "Address not found",
  Coinbase_transaction_cannot_be_canceled:
    "Coinbase transactions cannot be canceled.",
  Unfreeze_transaction_cannot_be_canceled:
    "Unfreeze transactions cannot be canceled.",
  Key_not_found: "Key not found",
  Token_not_found: "Token not found",
  Transaction_fee_must_be_equal_or_greater_than_0:
    "Transaction fee must be equal or greater than 0",
  Requested_amount_should_not_be_less_than_BOA:
    "Requested amount should not be 0 BOA",
  Data_size_cannot_be_greater_than_maximum:
    "Data size cannot be greater than maximum",
  Insufficient_balance: "Insufficient balance",
  The_transaction_is_invalid_cannot_be_canceled:
    "The transaction is invalid, cannot be canceled",
  Not_enough_fee_to_cancel_pending_transaction:
    "Not enough fee to cancel pending transaction",
  Problem_occurred_while_applying_transaction_cancellation:
    "Problem occurred while applying transaction cancellation",
  Field: "Field",
  Transaction_moved_from_pending:
    "This transaction is moved from pending state.",
  Are_you_sure_you_want_to_delete_this_address:
    "Are you sure you want to delete this address ?",
  Are_you_sure_you_want_to_delete_this_account:
    "Are you sure you want to delete this account ?",
  Are_you_sure_you_want_to_delete_the_selected_senders_address:
    "Are you sure you want to delete the selected sender's address ?",
  Changes_exist_Are_you_sure_you_want_to_cancel:
    "Changes exist. Are you sure you want to cancel?",
  The_amount_to_be_transferred_has_not_been_filled_yet:
    "The amount to be transferred has not been filled yet.",
  Please_check_the_amount_again: "Please check the amount again.",
  Copied: "Copied",
  High: "High",
  Medium: "Medium",
  Low: "Low",
  Enter_Address: "Enter Address",
  Payload: "Payload",
  Local_Time: "Local Time",

  //SDK Types Message
  Success: "Success",
  FailedAccessToAgora: "Failed access to Agora.",
  FailedAccessToStoa: "Failed access to Stoa.",
  FailedRequestHeight: "Failed to process a request for block height.",
  FailedRequestBalance:
    "Failed to process a request for the balance of the account.",
  FailedRequestUTXO: "Failed to process a request for UTXOs.",
  FailedRequestUTXOInfo: "Failed to process a request for UTXO information.",
  FailedRequestTransactionHistory:
    "Failed to process a request for the history of the transactions.",
  FailedRequestTransactionPending:
    "Failed to process a request for the list of the pending transactions.",
  FailedRequestTransactionDetail:
    "Failed to process a request for the detail of a transaction.",
  FailedRequestTransactionOverview:
    "Failed to process a request for the overview of a transaction.",
  FailedRequestTransaction: "Failed to process a request for a transaction.",
  FailedRequestPendingTransaction:
    "Failed to process a request for a pending transaction.",
  FailedRequestTxFee:
    "Failed to process a request for the fee of the transaction.",
  FailedRequestVotingFee: "Failed to process a request for voting fee.",
  FailedVerifyPayment:
    "Failed to process a request for verify payment of the transaction.",

  NotExistReceiver: "Not exists any receiver.",
  NotEnoughAmount: "Not enough amount.",

  // Cancellation of Transaction
  Cancel_NotAllowCoinbase: "Transactions of type Coinbase cannot be canceled.",
  Cancel_InvalidTransaction: "This is not a valid transaction.",
  Cancel_NotAllowUnfreezing: "Unfreeze transactions cannot be canceled.",
  Cancel_NotFoundUTXO: "UTXO information not found.",
  Cancel_UnsupportedLockType: "This LockType not supported by cancel feature.",
  Cancel_NotFoundKey: "Secret key not found.",
  Cancel_NotEnoughFee: "Not enough fees are needed to cancel.",
  Cancel_NotAssignedTx: "Not assigned a transaction.",
  Cancel_CancellationTx:
    "This transaction has already been canceled. Do you want to resend it?",

  NotAssignedReceiver: "Not assigned any receiver.",
  NotAssignedReceiverAmount: "Not assigned any receiver amount.",
  InsufficientAmount: "Insufficient amount.",
  ExistUnknownSecretKey: "An account exists where the secret key is unknown.",
  NotAssignedSender: "Not assigned any sender.",
  AmountIsZero: "The amount to be transferred is zero.",
  FailedBuildTransaction:
    "An exception occurred in the process of building a transaction.",
  FailedSendTx: "Failed to process a transfer transaction.",

  // Unfreezing of UTXO
  Unfreeze_UnsupportedLockType:
    "The key type of the entered UTXO is not supported by this function.",
  Unfreeze_NotUTXOOwnedAccount:
    "This is not UTXO owned by a registered account.",
  Unfreeze_NotFrozenUTXO: "The entered UTXO is not frozen.",
  Unfreeze_NotFoundUTXO:
    "The information on the entered UTXO could not be found on the server. Please check if it's already been used.",
  Unfreeze_AlreadyAdded: "The entered UTXO has already been added.",
  Unfreeze_NotAssignedUTXO: "No frozen UTXO has been added.",
  Unfreeze_ExistNotFrozenUTXO:
    "Among the entered UTXOs, there are some that are not frozen.",

  // Valid Public Key
  InvalidPublicKey: "This is not a valid public key.",
  InvalidPublicKeyLength: "This is not a valid public key length.",
  InvalidPublicKeyFormat: "This is not a valid public key format.",

  // Valid Secret Key
  InvalidSecretKey: "This is not a valid secret key.",
  InvalidSecretKeyLength: "This is not a valid secret key length.",
  InvalidSecretKeyFormat: "This is not a valid secret key format.",

  // Valid KeyPair
  InvalidKeyPair: "This is not a valid key pair.",

  // Valid Hash
  InvalidHash: "This is not a valid hash.",
  InvalidHashLength: "This is not a valid hash length.",
  InvalidHashFormat: "This is not a valid hash format.",

  // Valid Amount
  InvalidAmount: "This is not a valid amount.",
  InvalidAmountFormat: "This is not a valid amount format.",

  UnknownError: "Unknown error occurred.",

  SystemError: "System error occurred.",

  No_Response_URL:
    "This is an address with no response. Please enter the address of the activated server.",
};
